export const postOpStackCodes = {
  owned: "owned",
  list: "list",
  item: "item",
};

export const defaultStackItem = {
  code: postOpStackCodes.owned,
};
